export { DMS_MODULE } from '../constants';
export const NAME = 'NonReceivedPartsPO';
export const API_NAME = 'NonReceivedPartsPO';
export const EXPORT_FILE_NAME = 'NonReceivedPartsPO.xlsx';
export const CRUMB_LABEL_KEY = 'NonReceivedPartsPO';
export const PROrdersParts = 'PROrdersParts';
export const PRNAME = 'PROrdersParts';
export const addThreeMonths = 3;
export const subtractOneDay = 1;
export const DEPENDENT_TABLES = <const>[
	PROrdersParts,
];
export type DependentTableNames = typeof DEPENDENT_TABLES[number];

export type SestavaButton = { labelKey: string, routeName: string, api: string, permission: number };
